import { jsx as _jsx } from "react/jsx-runtime";
import { kebabCase } from 'lodash';
import { useLayoutEffect } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { AccountContext } from 'contexts/account';
import { useAccountDataQuery } from 'queries/account';
export const AccountProvider = ({ children })=>{
    const { data } = useAccountDataQuery();
    useLayoutEffect(()=>{
        if (data) {
            const { account: { metaData } } = data;
            if (metaData) {
                const { theme } = metaData;
                if (theme) {
                    const root = document.documentElement;
                    Object.keys(theme).forEach((variable)=>{
                        const variableValue = theme[variable];
                        if (variableValue) {
                            root.style.setProperty(`--${kebabCase(variable)}`, variableValue);
                        }
                    });
                }
            }
        }
    }, [
        data
    ]);
    if (data) {
        return /*#__PURE__*/ _jsx(AccountContext.Provider, {
            value: data.account,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(PageLoading, {
        size: "large"
    });
};
